import "./GameFeatureContent.css";
import { CheckCircle2, ArrowRight } from "lucide-react";

const GameFeatureContent = ({
  badge,
  title,
  description,
  features = [],
  whatsappMessage = "Hi! I'm interested in your game development services."
}) => {

  const whatsappNumber = "919653304639"; // Replace with your WhatsApp number

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="game-feature-content">

      <span className="feature-badge">
        {badge}
      </span>

      <h2>{title}</h2>

      <p>{description}</p>

      <div className="feature-list">

        {features.map((feature, index) => (
          <div
            className="feature-item"
            key={index}
          >
            <CheckCircle2 size={18} />
            <span>{feature}</span>
          </div>
        ))}

      </div>

      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="feature-button"
      >
        Discuss Your Project
        <ArrowRight size={18} />
      </a>

    </div>
  );
};

export default GameFeatureContent;